export const navLinks = [
  { id: "categories", label: "分类总览", icon: "ri-apps-2-line" },
  { id: "picks", label: "编辑精选", icon: "ri-award-line" },
  { id: "sites", label: "收录列表", icon: "ri-list-check-2" },
  { id: "downloads", label: "工具下载", icon: "ri-download-2-line" },
  { id: "submit", label: "收录申请", icon: "ri-add-circle-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-line" },
];

export const heroEntries = [
  {
    name: "常用工具",
    desc: "截图转格式、压缩批处理，打开即用",
    icon: "ri-tools-line",
    count: "168 个站点",
    tone: "primary",
  },
  {
    name: "影视娱乐",
    desc: "追剧看片、弹幕社区、音乐电台",
    icon: "ri-film-line",
    count: "132 个站点",
    tone: "accent",
  },
  {
    name: "学习资源",
    desc: "公开课、题库文档、技能速成",
    icon: "ri-book-2-line",
    count: "97 个站点",
    tone: "secondary",
  },
  {
    name: "生活服务",
    desc: "缴费办事、地图出行、便民查询",
    icon: "ri-service-line",
    count: "84 个站点",
    tone: "primary",
  },
  {
    name: "资讯阅读",
    desc: "要闻速览、深度长文、垂直媒体",
    icon: "ri-newspaper-line",
    count: "76 个站点",
    tone: "accent",
  },
  {
    name: "数码科技",
    desc: "评测拆解、开发者社区、极客好物",
    icon: "ri-cpu-line",
    count: "63 个站点",
    tone: "secondary",
  },
];

export const heroStats = [
  { value: "1,286", label: "已收录站点" },
  { value: "26", label: "细分分类" },
  { value: "98", label: "每日巡检条目" },
  { value: "7", label: "年持续整理" },
];